import React from "react";
import withTheme from "../../hoc/withTheme";
import { BrowserRouter } from "react-router-dom";

import AdminRoutes from "./routes";

const AdminContainerClientWrapper = () => (
  <BrowserRouter basename="/admin">
    <AdminRoutes />
  </BrowserRouter>
);

export default withTheme(AdminContainerClientWrapper);
